/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import { DocumentValueType } from '../Types/CommonTypes';

export type MemberStatusRequestType = {
  /** N* Smiles */
  memberNumber?: string;
  /** Dados do documento CPF, RNE ou PASSAPORTE */
  document?: DocumentValueType;
  email?: string;
  /** Token RECAPTCHA Google V2 */
  recaptcha?: {
    responseToken?: string;
  };
};

const definitions = Definitions.MemberStatus;

const callPost = async (
  params: MemberStatusRequestType,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };

export default { call, definitions };
